import config from '@/config';

export const BASE_URL = config.resources_url;
export const FRONTEND_URL = config.frontend_url || '';
export const IS_LOCAL_ENVIRONMENT = FRONTEND_URL.includes('localhost');
export const USE_DUMMY_GAME_DATA = config.use_dummy_game_data;
